export default "__VITE_ASSET__DNb6Ez1m__"